export default class StickyController {
	static BENCHMARK_PADDING = 40;

	constructor(element) {
		if (element === undefined) return;
		this.isFixed = false;
		this.stickyLimit = null;
		this.target = element;
		this.main = document.querySelector("main");
		this.header = document.querySelector("header");
		this.pageSectionHeadlines = Array.from(
			this.main.querySelectorAll(".js-main-content-headline")
		);
		this.mainSectionContents = Array.from(
			this.main.querySelectorAll(".js-main-section-content")
		);
		this.setPosition = ::this.setPosition;
		this.init();
	}

	init() {
		window.addEventListener("scroll", this.setPosition);
		window.addEventListener("resize", this.setPosition);
	}

	getTopOffset(element) {
		return element.getBoundingClientRect().top;
	}

	getHeight(element) {
		return element.getBoundingClientRect().height;
	}

	getPaddingBottom(element) {
		const padding = window.getComputedStyle(element)["padding-bottom"];
		return parseInt(padding.substring(0, padding.length - 2));
	}

	getTopValue() {
		const padding = window.getComputedStyle(this.mainSectionContents[0])[
			"padding-top"
		];
		return (
			parseInt(this.pageSectionHeadlines[0].getBoundingClientRect().height) +
			parseInt(padding.substring(0, padding.length - 2))
		);
	}

	getWidth() {
		const padding = window.getComputedStyle(this.target.parentElement)[
			"padding-left"
		];
		return (
			parseFloat(this.target.parentElement.getBoundingClientRect().width) -
			parseFloat(padding.substring(0, padding.length - 2)) * 2
		);
	}

	setPosition() {
		const topValue = this.getTopValue();
		const width = this.getWidth();

		const mainTop = this.getTopOffset(this.main);
		const targetTop = this.getTopOffset(this.target);
		const mainHeight = this.getHeight(this.main);
		const targetHeight = this.getHeight(this.target);
		const mainSectionContentPaddingBottom = this.getPaddingBottom(
			this.mainSectionContents[0]
		);

		if (this.isFixed)
			this.stickyLimit =
				targetTop + targetHeight + mainSectionContentPaddingBottom;
		const mainGap = mainHeight - Math.abs(mainTop);

		if (mainTop <= 0 && mainGap >= this.stickyLimit) {
			this.target.style.width = `${width}px`;
			if (this.isFixed) return;
			this.target.parentElement.style.verticalAlign = "";
			this.target.style.top = `${topValue}px`;
			this.target.style.position = "fixed";
			this.isFixed = true;
		} else {
			if (!this.isFixed) return;
			if (mainTop >= 0) {
				this.target.parentElement.style.verticalAlign = "top";
			} else {
				this.target.parentElement.style.verticalAlign = "bottom";
			}
			this.target.style.width = "";
			this.target.style.top = "";
			this.target.style.position = "";
			this.isFixed = false;
		}
	}
}



// WEBPACK FOOTER //
// ./Components/StickyController.js